import InteractionPoint from "../InteractionPoint";
import React from "react";
import { Html } from "@react-three/drei";

export default function OptometryLabInteractions() {
    return (
        <>

            <InteractionPoint
                args={[0.25, 0.25, 0.25]}
                position={[-4.715, 0.763, -1.318]}
                module={"boite"}
            ></InteractionPoint>
            <InteractionPoint
                args={[0.25, 0.25, 0.25]}
                position={[-3.74199, 1.163, -2.92029]}
                module={"biometre"}
            ></InteractionPoint>
            <InteractionPoint
                args={[0.25, 0.25, 0.25]}
                position={[-3.74199, 1.163, -2.92029]}
                module={"biometre"}
            ></InteractionPoint>
            <InteractionPoint
                args={[0.25, 0.25, 0.25]}
                position={[-3.92466, 1.49811, -4]}
                module={"keratometre"}
            ></InteractionPoint>
            <InteractionPoint
                args={[0.25, 0.25, 0.25]}
                position={[-6.54741, 2.914, 0.4]}
                module={"echelle"}
            ></InteractionPoint>
            <InteractionPoint
                args={[0.25, 0.25, 0.25]}
                position={[-4.3, 0.8, -0.043535]}
                module={"consultation"}
            ></InteractionPoint>

        </>
    );
}
